import * as Yup from "yup";

export const ShareStudyLinkSchema = Yup.object({
  email: Yup.string().required("Email is required").matches("^((([!#$%&'*+\\-/=?^_`{|}~\\w])|([!#$%&'*+\\-/=?^_`{|}~\\w][!#$%&'*+\\-/=?^_`{|}~\\.\\w]{0,}[!#$%&'*+\\-/=?^_`{|}~\\w]))[@]\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*)$","Email is not valid")
});
const emailRegex = /^((([!#$%&'*+\-/=?^_`{|}~\w])|([!#$%&'*+\-/=?^_`{|}~\w][!#$%&'*+\-/=?^_`{|}~.\w]{0,}[!#$%&'*+\-/=?^_`{|}~\w]))[@]\w+([-.]\w+)*\.\w+([-.]\w+)*)$/;

export const createShareStudyLinkSchema = (isEmailChecked = true, isWhatsappChecked = false) => {
  return Yup.object().shape({
    // only validate email when email checkbox is checked
    email: isEmailChecked
      ? Yup.string()
          .required("Email is required")
          .matches(emailRegex, "Email is not valid")
      : Yup.string().nullable(),

    // only require whatsappNo when whatsapp checkbox is checked
    whatsappNo: isWhatsappChecked
      ? Yup.string()
          .trim()
          .required("Whatsapp number is required")
      : Yup.string().nullable(),

    // keep studyShareUrl if you want to validate it in future
    studyShareUrl: Yup.string().nullable()
  });
};